import { render, staticRenderFns } from "./DefaultPageAskDelete.vue?vue&type=template&id=34d76e30&scoped=true&"
import script from "./DefaultPageAskDelete.vue?vue&type=script&lang=js&"
export * from "./DefaultPageAskDelete.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPageAskDelete.vue?vue&type=style&index=0&id=34d76e30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d76e30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
